import React from "react";
import HomeLayout from "../../layouts/HomeLayout";

export  const Home = () =><div className="w-full"><HomeLayout /></div>

